export default function (array, f) {
  var s = 0,
      n = array.length,
      a,
      i = -1;

  if (f == null) {
    while (++i < n) {
      if (a = +array[i]) s += a;
    } // Note: zero and null are equivalent.

  } else {
    while (++i < n) {
      if (a = +f(array[i], i, array)) s += a;
    }
  }

  return s;
}